function formInputId(widget) {
  if (!widget) {
    return "";
  }

  return `input-idx-${widget.id()}`;
}

function formInputName(widget) {
  if (!widget) {
    return "";
  }

  return `input-name-${widget.id()}`;
}

function getValidationResult(input, widgetId) {
  const reportedError = input.find((item) => item.id === widgetId);
  return reportedError ? reportedError.validation : null;
}

export { formInputId, formInputName, getValidationResult };
